<template>
    <div class="homeImages">
        <div class="aHref">
            <div class="coreContent">
                <img class="icon" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/dm_home/home_back6.png" alt="">
            </div>
            <div class="coreData left_top wow animate__animated animate__bounceIn" data-wow-delay ="0.2s">入库环节</div>
            <div class="coreData left_content_one wow animate__animated animate__bounceIn" data-wow-delay ="0.6s">提货环节</div>
            <div class="coreData left_content_two wow animate__animated animate__bounceIn" data-wow-delay ="1.0s">库存环节</div>
            <div class="coreData left_bottom wow animate__animated animate__bounceIn" data-wow-delay ="1.4s">费用环节</div>
            <div class="coreData right_top wow animate__animated animate__bounceIn" data-wow-delay ="0.2s">找货环节</div>
            <div class="coreData right_content_one wow animate__animated animate__bounceIn" data-wow-delay ="0.6s">装车环节</div>
            <div class="coreData right_content_two wow animate__animated animate__bounceIn" data-wow-delay ="1.0s">货权环节</div>
            <div class="coreData right_bottom wow animate__animated animate__bounceIn" data-wow-delay ="1.4s">第三方服务</div>
        </div>
    </div>
</template>
<script>
import {WOW} from 'wowjs'
export default {
    data(){
        return{
             
        }
    },
    watch:{
        
    },
    mounted(){
        this.$nextTick(() => {
            let wow = new WOW({
                boxClass: "wow",    //需要执行动画的元素的 class
                animateClass: "animated", // animation.css 动画的 class
                offset: 0, // 距离可视区域多少开始执行动画
                mobile: false, // 是否在移动设备上执行动画
                live: false // 异步加载的内容是否有效
            })
            wow.init()
        })
    },
    created(){
        
    },
    methods:{
        
    }
}
</script>
<style scoped  lang="scss">
    .homeImages .aHref{width: 100%;height:56rem;position: relative; overflow: hidden;display: block;border-radius: 0.4rem;box-shadow: 0 0 0.8rem rgba(51, 51, 51, 0.2);}
    .homeImages .aHref .icon{max-width: 100%;vertical-align: middle;transition: all .6s;}
    .homeImages .aHref .icon:hover{transform:scale(1.1);cursor: pointer;}
    .coreData{
        width: 12rem;
        height: 4rem;
        border-radius: 0.4rem;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 0.1rem solid #3A6DF2;
        color: #3A6DF2;
        font-weight: 600;
    }
    .coreData:hover{
        background: #3A6DF2;
        color: #fff;
        cursor: pointer;
    }
    .coreContent{
        width: 45rem;
        height: 20rem;
        border-radius: 4rem;
        transform: translateX(-50%) translateY(-50%);
        position: absolute;
        left: 50%;
        top: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .left_top{
        position: absolute;
        left: 25%;
        top: 8%;
    }
    .left_content_one{
        position: absolute;
        left: 13%;
        top: 30%;
    }
    .left_content_two{
        position: absolute;
        left: 13%;
        top: 55%;
    }
    .left_bottom{
        position: absolute;
        left: 25%;
        top: 80%;
    }
    .right_top{
        position: absolute;
        left: 65%;
        top: 8%;
    }
    .right_content_one{
        position: absolute;
        left: 77%;
        top: 30%;
    }
    .right_content_two{
        position: absolute;
        left: 77%;
        top: 55%;
    }
    .right_bottom{
        position: absolute;
        left: 65%;
        top: 80%;
    }
</style>